import { ChevronLeft } from 'lucide-react'
import React, { useState } from 'react'
import CustomCheckbox2 from '../../../BuisnessDashboard/common/CustomCheckbox2'
export default function AddCampaign({ handleCustomTab }) {
    const [objectData, setObjectData] = useState({
        campaignName: "",
        campaignCode: "",
        campaignStatus: "",
        partnerId: "",
        campaignStartDate: "",
        campaignEndDate: "",
        pricingOveride: "",
        platform: "",
        autoPause: false,
    })

    const handleChange = (e, type) => {
        const { value, checked } = e.target;
        setObjectData((prev)=>({
            ...prev,
            [type]: type == "autoPause" ? checked : value
        }))
    }
    return (
        <>
            <div className='OverView-Main-Section'>
                <div className='HeadingFilter-Section'>
                    <div>
                        <h4 style={{ display: 'inline-flex', gap: '5px', alignItems: 'center',cursor:'pointer' }} onClick={() => handleCustomTab("", "")}><ChevronLeft style={{ width: 'auto' }} /> Campaign Registration</h4>
                    </div>
                    <div className='topsTabs' style={{ border: 'none' }}>
                        <div className='rightTabs' style={{ padding: '0' }}>
                            <button className={`rightSideBtn `} style={{ border: '1px solid #035865', color: '#035865' }} >Cancel</button>
                            <button className={`rightSideBtn active`} style={{ background: '#035865', color: '#fff' }} >Save</button>
                        </div>
                    </div>
                </div>

                <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee', marginTop: '20px' }}>
                    <div className="row">
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Campaign Name</label>
                                <input className='customInput-new' type="text" value={objectData?.campaignName} onChange={(e)=>handleChange(e,"campaignName")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Campaign Code</label>
                                <input className='customInput-new' type="text" value={objectData?.campaignCode} onChange={(e)=>handleChange(e,"campaignCode")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Campaign Status</label>
                                <input className='customInput-new' type="text" value={objectData?.campaignStatus} onChange={(e)=>handleChange(e,"campaignStatus")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Partner ID</label>
                                <input className='customInput-new' type="text" value={objectData?.partnerId} onChange={(e)=>handleChange(e,"partnerId")}/>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:'20px'}}>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Campaign Start Date</label>
                                <input className='customInput-new' type="date" value={objectData?.campaignStartDate} onChange={(e)=>handleChange(e,"campaignStartDate")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Campaign End Date</label>
                                <input className='customInput-new' type="date" value={objectData?.campaignEndDate} onChange={(e)=>handleChange(e,"campaignEndDate")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Pricing Override</label>
                                <input className='customInput-new' type="text" value={objectData?.pricingOveride} onChange={(e)=>handleChange(e,"pricingOveride")}/>
                            </div>
                        </div>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box'>
                                <label htmlFor="" className="label-new">Platform</label>
                                <input className='customInput-new' type="text" value={objectData?.platform} onChange={(e)=>handleChange(e,"platform")}/>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:'20px'}}>
                        <div className="col-sm-3 col-xs-12">
                            <div className='customInput-box' style={{display:'flex',gap:'10px',alignItems:'center'}}>
                                <CustomCheckbox2 
                                checked={objectData?.autoPause}
                                onChange={(e)=>handleChange(e,"autoPause")}
                                />
                                <label htmlFor="" className="label-new">Auto Pause on Budget Exhaust</label>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </>
    )
}
